import { useQuery } from "@tanstack/react-query";
import { getProjectAccess } from "../api";
import { useAuth } from "src/features/auth/AuthContext";

export function useProjectAccess(projectId?: string) {
    const { me } = useAuth();

    return useQuery({
        queryKey: ['projectAccess', projectId, me?.id ?? 'anon'],
        queryFn: () => getProjectAccess(projectId as string),
        enabled: !!projectId && !!me?.id,
        staleTime: 60_000,
    });
}

export function hasPerm(perms: string[] | undefined | null, key: string) {
    return !!perms?.includes(key);
}
